import qs, { IStringifyOptions } from 'qs';

const urlFormatOptions: IStringifyOptions = { arrayFormat: 'comma' };

const urlize = (params: any) => qs.stringify(params, urlFormatOptions);

export default urlize;
